
<template>
  <div>
    <el-dialog
      :visible.sync="addCustormDialog"
      width="856px"
      title="添加客户"
      @close="onClose"
      append-to-body
    >
      <el-form
        :model="queryParams"
        :rules="queryParamsRules"
        ref="queryParamsRefs"
        label-width="95px"
        class="demo-form-inline"
        style="padding-right:30px;padding-left:7px"
      >
        <el-row :gutter="10">
          <el-col :span="16">
            <el-col :span="18">
              <el-form-item label="客户名称：" prop="cusName">
                <el-input
                  v-model="queryParams.cusName"
                  @input="changeName"
                  @keyup.native.enter="onSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="0px">
                <el-button type="primary" @click="onSearch(queryParams.cusName)">查询</el-button>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属行业：">
              <el-select v-model="queryParams.cusIndustry" placeholder="请选择">
                <el-option
                  v-for="(item,index) in industryTypeList"
                  :key="index"
                  :label="item.attrName"
                  :value="item.attrName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户来源：">
              <el-select v-model="queryParams.cusFrom" placeholder="请选择">
                <el-option
                  v-for="(item,index) in fromTypeList"
                  :key="index"
                  :label="item.attrName"
                  :value="item.attrName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="付款方式：">
              <el-select v-model="queryParams.cusPaytype" placeholder="请选择">
                <el-option
                  v-for="(item,index) in payTypeList"
                  :key="index"
                  :label="item.attrName"
                  :value="item.attrName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="queryParams.cusPaytype==='约定账期'">
            <el-form-item
              label="账期设置："
              style="margin:0px;height:49px"
              :rules="filter_rules({required:true})"
            >
              <el-col :span="12">
                <el-select v-model="queryParams.accountType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in paymentDaySetList"
                    :key="index"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="11" style="padding-left:10px;">
                <el-input v-model="queryParams.days" placeholder="请设置约定天数"></el-input>
              </el-col>
              <el-col :span="1" style="padding-left:10px">
                <el-form-item label-width="0px">天</el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="委托人：">
              <el-select
                v-model="queryParams.clientId"
                filterable
                reserve-keyword
                placeholder="请选择委托人"
              >
                <el-option
                  v-for="(item,index) in clientList"
                  :key="index"
                  :label="item.staffCnName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人：" prop="ccContacts">
              <el-input v-model.trim="queryParams.ccContacts"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="ccPhone">
              <el-input @input.native="onInput" v-model.trim="queryParams.ccPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系手机：">
              <el-input
                v-model.trim="queryParams.ccMobile"
                 @input.native="onInput"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-center">
        <el-button type="primary" @click="onFastAdd" :disabled="checks">提 交</el-button>
        <el-button @click="onClose">取 消</el-button>
      </span>
    </el-dialog>
    <!--------------查询企业 -------------->
    <invoice-search-dialog @invoiceSearchDialog="invoiceSearchDialog" ref="invoiceSearchDialogRefs"></invoice-search-dialog>
    <!-- 验证码 -->
    <qrcode-dialog @qrcodeDialog="qrcodeDialog" ref="qrcodeDialogRefs"></qrcode-dialog>
  </div>
</template>

<script>
import invoiceSearchDialog from './invoiceSearchDialog'
import qrcodeDialog from './qrcodeDialog'
import {
  queryEnterQueryEin,
  addFast,
  queryStaffBaseByClient,
  queryByCusName
} from '@/api/customer/customerManage'

import { paymentDaySetList } from '../../custorm/utils/data'

export default {
  components: {
    'invoice-search-dialog': invoiceSearchDialog,
    'qrcode-dialog': qrcodeDialog
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      const myreg = /^[1][3,5,6,7,8,9][0-9]{9}$/
      if (!myreg.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('联系人不能为空'))
      } else {
        callback()
      }
    }
    return {
      checks: true,
      clientList: [], // 委托人
      queryParams: {
        cusElp: ''
      },
      params: {},
      industryTypeList: [],
      fromTypeList: [],
      payTypeList: [],
      paymentDaySetList: paymentDaySetList, // 账期设置
      queryParamsRules: {
        ccPhone: [{ validator: checkPhone, trigger: 'blur', required: true }],
        ccContacts: [{ validator: checkName, trigger: 'blur', required: true }],
        cusName: [{ trigger: 'blur', required: true, message: '客户名称不能为空' }]
      },
      // queryParamsRules: ruleOfAddCunstormerData,
      addCustormDialog: false, // 添加客户弹框
      typeList: ['industry_type', 'from_type', 'paytype_type']
    }
  },

  methods: {
    onInput(e) {
      // 过滤非数字和符号
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    qrcodeDialog(formLabelAlign, data) {
      this.$refs.invoiceSearchDialogRefs.onInitial(data, formLabelAlign)
    },
    // 客户名称change事件
    changeName(val) {
      this.checks = true
    },
    // 查新客户返回emit
    invoiceSearchDialog(val) {
      this.queryParams.cusName = val.entname
      this.queryParams.cusElp = val.legalname
      this.queryParams.suRegdate = val.esdate
      queryEnterQueryEin(val.id)
        .then(res => {
          if (res.data.code === 200) {
            this.checks = false
            this.queryParams.entname = res.data.obj.entname
            this.queryParams.gongsh = res.data.obj.gongsh
            this.queryParams.orgcode = res.data.obj.orgcode
            this.queryParams.ciTaxcode = res.data.obj.uncid
            this.queryParams.suRegdat = res.data.obj.esdate
            this.queryParams.bizProvince = res.data.obj.bizProvince
            if (res.data.obj.village) {
              this.$set(this.queryParams, 'bizAddress', res.data.obj.village)
            } else {
              this.$set(this.queryParams, 'bizAddress', res.data.obj.oploc)
            }
            this.$emit('onCompanyName', res.data.obj)
            if (this.queryParams.bizProvince !== null) {
              const ManageParams = this.$analysisAddressName(this.queryParams.bizProvince)
              const arr = [] // 这是有用的
              arr.push(ManageParams.province.id)
              arr.push(ManageParams.city.id)
              arr.push(ManageParams.district.id)
              this.queryParams.bizProcode = arr.join('-')
              this.provinceReceiving = ManageParams.province
              this.cityReceiving = ManageParams.city
              this.districtReceiving = ManageParams.district
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 查询
    onSearch(cusName) {
      if (!cusName) {
        this.$message.error('客户名称不能为空')
      } else {
        queryByCusName(this.queryParams.cusName)
          .then(res => {
            if (res.data.code === 200) {
              this.$refs.qrcodeDialogRefs.onInitial(cusName)
              this.$message.success('客户名称验证通过')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    // 系列加载
    getSupplierList(currentPage, data) {
      queryStaffBaseByClient(currentPage, this.pageSize, this.queryParams.bid)
        .then(res => {
          if (res.data.code === 200) {
            if (currentPage === 1) {
              this.seriesList = res.data.obj.records
            } else {
              const arrList = res.data.obj.records
              this.seriesList = this.seriesList.concat(arrList)
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadmore() {
      this.currentPage++
      this.getSupplierList(this.currentPage)
    },
    // 获取数据
    getList() {
      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }
      queryStaffBaseByClient(1, 100, params)
        .then(res => {
          if (res.data.code === 200) {
            this.clientList = res.data.obj.records
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getListAll(val) {
      this.params = {
        column: 'staffCnName',
        value: val
      }
      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }
      queryStaffBaseByClient(1, 10000, params)
        .then(res => {
          if (res.data.code === 200) {
            this.clientList = res.data.obj.records
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 快速添加初始化
    quickAddInit() {
      this.addCustormDialog = true
      this.queryParams = {
        ccContacts: '',
        ccMobile: '',
        ccPhone: '',
        cusFrom: '',
        cusIndustry: '',
        cusName: '',
        cusPaytype: ''
      }
      this.getList()
      this.getQueryByClassCode()
    },
    async getQueryByClassCode() {
      const params = await this.$queryByClassCode(this.typeList)
      try {
        this.payTypeList = params.payTypeList
        this.industryTypeList = params.industryTypeList
        this.fromTypeList = params.fromTypeList
      } catch (e) {
        console.log(e)
      }
    },
    // 快速添加客户
    onFastAdd() {
      this.$refs.queryParamsRefs.validate(valid => {
        if (valid) {
          // this.clientList.forEach(element => {
          //   if ((element.id = this.queryParams.clientId)) {
          //     this.queryParams.clientOrg = element.coId
          //   }
          // })
          if (this.queryParams.cusPaytype === '约定账期') {
            if (!this.queryParams.accountType || !this.queryParams.days) {
              this.$message.error('账期设置不能为空')
            } else {
              if (this.queryParams.cusElp === undefined) {
                this.$message.error('请查询公司是否存在')
              } else {
                addFast(this.queryParams)
                  .then(res => {
                    if (res.data.code === 200) {
                      this.$message.success('添加成功!')
                      this.addCustormDialog = false
                      this.$emit('getList')
                      if (this.$route.name === 'myCustomer') {
                        this.$router.push({
                          path: 'myCustomer',
                          query: {
                            cusState: 'potentialCustomers'
                          }
                        })
                      }
                    } else {
                      this.$message.error(res.data.msg)
                    }
                  })
                  .catch(err => {
                    console.log(err)
                  })
              }
            }
          } else {
            if (this.queryParams.cusElp === undefined) {
              this.$message.error('请查询公司是否存在')
            } else {
              addFast(this.queryParams)
                .then(res => {
                  if (res.data.code === 200) {
                    this.$message.success('添加成功!')
                    this.addCustormDialog = false
                    this.$emit('getList')
                    if (this.$route.name === 'myCustomer') {
                      this.$router.push({
                        path: 'myCustomer',
                        query: {
                          cusState: 'potentialCustomers'
                        }
                      })
                    }
                  } else {
                    this.$message.error(res.data.msg)
                  }
                })
                .catch(err => {
                  console.log(err)
                })
            }
          }
        }
      })
    },
    // 关闭弹窗
    onClose(formName) {
      this.queryParams = {}
      this.addCustormDialog = false
      this.$refs.queryParamsRefs.clearValidate() // 去掉校验
    }
  }
}
</script>
